import React from 'react'
import PropTypes from 'prop-types'
import { InlineShareButtons, StickyShareButtons } from 'sharethis-reactjs'
import Wrapper from './ShareButtons.style'
import { inlineProps, stickyProps } from './ShareButtonsProps'
import { useHasMounted } from '../../utils/hooks'

const ShareButtons = ({ variation, ...rest }) => {
  const hasMounted = useHasMounted()
  if (!hasMounted) {
    return null
  }
  const stickyShareProps = {
    ...stickyProps,
    ...rest,
    variation,
  }

  const inlineShareProps = {
    ...inlineProps,
    ...rest,
    variation,
  }

  const sharethisScript = document.getElementById('sharethis-js')

  if (sharethisScript) {
    sharethisScript.remove()
    // eslint-disable-next-line no-underscore-dangle
    delete window.__sharethis__
  }

  if (variation === 'sticky') {
    return (
      <Wrapper>
        <StickyShareButtons config={stickyShareProps} />
      </Wrapper>
    )
  }
  return (
    <Wrapper>
      <InlineShareButtons config={inlineShareProps} />
    </Wrapper>
  )
}

ShareButtons.propTypes = {
  variation: PropTypes.string,
}

ShareButtons.defaultProps = {
  variation: 'inline',
}

export default ShareButtons
